var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.schoolControlEnabled)?_c('kn-form-assign-teacher-and-subject-to-group'):_c('kn-form-assign-teacher-to-group')
}
var staticRenderFns = []

export { render, staticRenderFns }